define([
    "./addressModule",
    "./addressFormat",
    "./nlgAddressEdition",
    "./AddressSelectionController",
    "./addressDependencyHelper",
    "./addressServiceUrls",
    "./viaCepServiceUrl"
], function () {
});